import { render } from "./JourneyPassengerSelect.vue?vue&type=template&id=c2ad93b4&scoped=true&lang=pug"
import script from "./JourneyPassengerSelect.vue?vue&type=script&lang=ts"
export * from "./JourneyPassengerSelect.vue?vue&type=script&lang=ts"

import "./JourneyPassengerSelect.vue?vue&type=style&index=0&id=c2ad93b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2ad93b4"

export default script